<script>
// assets/project/src/components/Main.vue
import axios from "axios";
import BasePdfUploader from "./Base/BasePdfUploader";
import DataInput from "./Base/DataInput";
import DataInputSimple from "./Base/DataInputSimple";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import SearchTagAutocomlete from "./Base/SearchTagAutocomlete";
import BaseJsonField from "./Base/BaseJsonField";
import BaseLocation from "./Base/BaseLocation";
import BaseLocationCountryRegionCity from "./Base/BaseLocationCountryRegionCity.vue";
import BaseInput from "./Base/BaseInput";
import SaveInfo from "./Base/SaveInfo";
import TinymceEditor from "./Base/TinymceEditor";
import moment from 'moment';
import Pagination from "./Base/PaginationComponent";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faQuestion} from '@fortawesome/free-solid-svg-icons';
import QuestionText1 from "./Base/QuestionText1";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";
import CustomFields from "@/components/Components/CustomFields.vue";
import { UploadOutlined } from '@ant-design/icons-vue';

library.add(faQuestion);

const project_data = {
	predpol_country: '',
	predpol_city: '',
	predpol_region: '',
	tritment: '',
	additional_document: '',
	regiser_eksplikatsia: '',
	age_limit: '',
	partners_fin: '',
	partners_org: '',
	partners_info: '',
	anketa_doverenost_litsa: '',
	anketa_ystav_copy: '',
	anketa_gossvidetelstvo: '',
	anketa_copy_pasport: '',
	anketa_spravka_knd: '',
	receipt_number: '',
	themes: [],
	predpol_locations: [
		{
			'predpol_country': '',
			'predpol_city': '',
			'predpol_region': ''
		}
	]
};

export default {
	name: 'MainComponent',
	data() {
		return {
			project: {
				annotation: '.',
				project_command: {
					producer: []
				}
			},
			receiptFileList: [],
			isReceiptUploading: false,
			projectSmeta: {
				motivation: '',
				auditory: '',
				numCopy: 0,
				countZritelei: 0,
				kassa: 0,
				budget: 0,
				dohodproducer: 0,
				dohodtv: 0,
				dohoddvd: 0
			},
			projectVisual: {
				production: '',
				country: '',
				actual: '',
				tizer: '',
				refference: '',
				visual_image: '',
				location: '',
				music_costruction: '',
				visual_decision: '',
				predpodperiod_begin: '',
				predpodperiod_end: '',
				predpodperiod_days: 0,
				podperiodbegin: '',
				podperiodend: '',
				podperiod_days: 0,
				siemochniperiodbegin: '',
				siemochniperiodend: '',
				siemochniperioddays: 0,
				mtperiodbegin: '',
				mtperiodend: '',
				mtperioddays: 0,
				prokatbegin: '',
				prokatend: '',
				prokatdays: 0
			},
			projectCommand: {
				producer: []
			},
			projectData: {
				'age_limit': ''
			},
			countriesinput: [],
			selected_country: '',
			citiestoinput: [],
			imgSrc: '',
			origfilename: '',
			modalStep: 0,
			tabNum: 1,
			currentCommand: [],
			errors: [],
			isLoading: true,
			isSubmitted: false,
			isDataUpdating: false,
			validationRules: [],
			competitions: [],
			totalCompetitions: 0,
			isShow: false,
			selectedCompetitionId: 0,
			currentPageNum: 0,
			isUserFillProfile: false,
			competitionMode: false,
			questionMode: false,
			formFields: [],
			customFieldsTabRef: null,
			lastCheckedReceiptNumber: '',
			receiptVerificationStatus: null,
			isReceiptVerifying: false,
		}
	},
	components: {
		CustomFields,
		BasePdfUploader,
		BaseLocationCountryRegionCity,
		VueCropper,
		UploadOutlined,
		BaseJsonField,
		DataInput,
		SearchTagAutocomlete,
		DataInputSimple,
		BaseInput,
		TinymceEditor,
		Pagination,
		SaveInfo,
		BaseLocation,
		FontAwesomeIcon,
		QuestionText1,
		ImageRender
	},
	mounted: function () {
		if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
			alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
		}
		this.checkIsUserFillProfile().then(() => {
			//Если выбран активный конкурс, куда подается заявка.
			if (window.competitionId?.length > 0) {
				this.selectedCompetitionId = window.competitionId;
				this.loadCompetition(this.selectedCompetitionId);
				if (window?.new?.length > 0) {
					this.getData(false, false);
				} else {
					this.getData(true, false);
				}
			} else {
				//Если после добавления нового проекта
				if (window?.new?.length > 0) {
					this.getData(false);
				} else {
					this.getData()
				}
				this.loadCompetitions(1);
			}
			
		});
	},
	computed: {
		totalPages: function () {
			return Math.ceil(this.totalCompetitions / 10)
		},
		hasCustomFields() {
			return this.formFields.length > 0 || (this.project.project_data && this.project.project_data.custom_fields && Object.keys(this.project.project_data.custom_fields).length > 0);
		},
		currentProjectId: function () {
			return window.projectId;
		},
		windowCompetitionId: function () {
			return window.competitionId;
		},
		isCountryFilled() {
			let res = false;
			if (this.project.country && this.project.country.length > 0) {
				res = true;
			}
			return res;
		},
		isCityFilled() {
			let res = false;
			if (this.project.city && this.project.city.length > 0) {
				res = true;
			}
			return res;
		},
		selectedCompetition() {
			return this.competitions.find(el => el.id === parseInt(this.selectedCompetitionId));
		},
		isTab1Visible() {
			return this.isFieldVisible('name') ||
				this.isFieldVisible('category') ||
				this.isFieldVisible('zhanr') ||
				this.isFieldVisible('tagline') ||
				this.isFieldVisible('logline') ||
				this.isFieldVisible('annotation') ||
				this.isFieldVisible('chronometr') ||
				this.isFieldVisible('stage') ||
				this.isFieldVisible('predpol_locations') ||
				this.isFieldVisible('scenario') ||
				this.isFieldVisible('tritment') ||
				this.isFieldVisible('sinopsis') ||
				this.isFieldVisible('presentation_about') ||
				this.isFieldVisible('motivation') ||
				this.isFieldVisible('scenario_author') ||
				this.isFieldVisible('scenario_rights') ||
				this.isFieldVisible('production') ||
				this.isFieldVisible('additional_info') ||
				this.isFieldVisible('additional_document') ||
				this.isFieldVisible('afisha') ||
				this.isFieldVisible('actual') ||
				this.isFieldVisible('auditory');
		},
	},
	methods: {
		formatCompetitionDate(date) {
			return moment(date).format('M/D/YYYY')
		},
		get_uploaded_image_asset(path) {
			return ImageService.getCompetitionImagePath(path);
		},
		showModal() {
			if (window.new.length > 0) {
				this.checkErrors()
			}
			this.isShow = true;
			this.competitionMode = true;
		},
		showModalRequest() {
			this.checkErrors()
			this.isShow = true;
			this.competitionMode = true;
		},
		showModalQuestion() {
			this.isShow = true;
			this.questionMode = true;
		},
		closeModal() {
			this.isShow = false;
			this.competitionMode = false;
			this.questionMode = false;
		},
		beforeReceiptUpload(file) {
			const isValidType = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
			if (!isValidType) {
				alert('Можно загружать только PDF, PNG или JPG файлы');
				return false;
			}
			
			const isValidSize = file.size / 1024 / 1024 < 10; // 10MB
			if (!isValidSize) {
				alert('Размер файла не должен превышать 10 МБ');
				return false;
			}
			
			this.uploadReceiptFile(file);
			return false; // Предотвращаем автоматическую загрузку
		},
		
		// New: Загрузка файла чека
		async uploadReceiptFile(file) {
			this.isReceiptUploading = true;
			
			const formData = new FormData();
			formData.append('receipt_file', file);
			
			try {
				const response = await axios.post(`/project/uploadReceiptFile/${this.project.id}`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					}
				});
				
				// Обновляем данные проекта
				if (!this.project.project_data) {
					this.project.project_data = {};
				}
				this.project.project_data.receipt_file = response.data.filename;
				
				// Очищаем список файлов в компоненте
				this.receiptFileList = [];
				
				alert('Файл успешно загружен');
				
			} catch (error) {
				console.error('Ошибка загрузки файла:', error);
				alert('Ошибка при загрузке файла');
			} finally {
				this.isReceiptUploading = false;
			}
		},
		
		// New: Удаление файла чека
		async removeReceiptFile() {
			if (!confirm('Вы уверены, что хотите удалить файл?')) {
				return;
			}
			
			try {
				await axios.delete(`/project/removeReceiptFile/${this.project.id}`);
				
				// Удаляем файл из данных проекта
				if (this.project.project_data) {
					delete this.project.project_data.receipt_file;
				}
				
				alert('Файл успешно удален');
				
			} catch (error) {
				console.error('Ошибка удаления файла:', error);
				alert('Ошибка при удалении файла');
			}
		},
		handleReceiptRemove() {
			this.receiptFileList = [];
			return true;
		},
		loadCompetition(id) {
			const self = this;
			axios.get('/competition/apiGetCompetition/' + id + '/' + window.projectId, {
				headers: {
					'Accept': 'application/ld+json',
				}
			})
				.then(response => {
					self.competitions = [response.data];
					self.isLoading = false;
				})
				.catch(error => {
					console.log(error);
				});
		},
		loadCompetitions(pageNum) {
			const self = this;
			this.currentPageNum = pageNum;
			self.isLoading = true;
			axios.get('/competition/apiGetCompetitions/' + window.projectId + '/' + pageNum, {
				headers: {
					'Accept': 'application/ld+json',
				}
			})
				.then(response => {
					self.isLoading = false;
					this.competitions = response.data['competitions'];
					this.totalCompetitions = response.data['total'];
				})
				.catch(error => {
					console.log(error);
				});
		},
		loadCountries() {
			const self = this;
			axios.get('/get_all_countries', {
				headers: {
					'Accept': 'application/json',
				}
			})
				.then(response => {
					self.countriesinput = response.data;
					
				})
				.catch(error => {
					console.log(error);
				});
		},
		loadCities() {
			const self = this;
			const current_country = self.countriesinput.filter(function (el) {
				return el["ru_name"] === self.project.country;
			})
			if (current_country[0] && current_country[0].number) {
				axios.get('/get_world_cities/' + current_country[0].number, {
					headers: {
						'Accept': 'application/json',
					}
				}).then((response) => {
					self.citiestoinput = response.data;
				}).catch(error => {
					console.log(error);
				});
			}
		},
		async getData(checkErrors = true, showModal = false) {
			const self = this;
			
			const response = await axios.get('/api/projects/' + window.projectId + '.json')
			
			if (response.data.anketaIp === null || (Array.isArray(response.data.anketaIp) && response.data.anketaIp.length === 0)) {
				response.data.anketaIp = {};
			}
			if (response.data.anketaIp.anketa_organization_name === undefined) {
				response.data.anketaIp.anketa_organization_name = '';
			}
			if (response.data.anketaIp.organization_name_short === undefined) {
				response.data.anketaIp.organization_name_short = '';
			}
			if (response.data.anketaIp.anketa_ogrn === undefined) {
				response.data.anketaIp.anketa_ogrn = '';
			}
			if (response.data.anketaIp.anketa_inn === undefined) {
				response.data.anketaIp.anketa_inn = '';
			}
			if (response.data.anketaIp.anketa_kpp === undefined) {
				response.data.anketaIp.anketa_kpp = '';
			}
			if (response.data.anketaIp.date_register_ip === undefined) {
				response.data.anketaIp.date_register_ip = '';
			}
			if (response.data.anketaIp.anketa_organization_address === undefined) {
				response.data.anketaIp.anketa_organization_address = '';
			}
			if (response.data.anketaIp.organization_address_fakt === undefined) {
				response.data.anketaIp.organization_address_fakt = '';
			}
			if (response.data.anketaIp.organization_address_notions === undefined) {
				response.data.anketaIp.organization_address_notions = '';
			}
			if (response.data.anketaIp.fio_boss === undefined) {
				response.data.anketaIp.fio_boss = '';
			}
			if (response.data.anketaIp.anketa_predstaviteli === undefined) {
				response.data.anketaIp.anketa_predstaviteli = '';
			}
			if (response.data.anketaIp.anketa_organization_email === undefined) {
				response.data.anketaIp.anketa_organization_email = '';
			}
			if (response.data.anketaIp.anketa_organization_phone === undefined) {
				response.data.anketaIp.anketa_organization_phone = '';
			}
			if (response.data.anketaIp.anketa_organization_nalogi === undefined) {
				response.data.anketaIp.anketa_organization_nalogi = '';
			}
			if (response.data.anketaIp.anketa_organization_rekviziti === undefined) {
				response.data.anketaIp.anketa_organization_rekviziti = '';
			}
			if (response.data.anketaIp.anketa_has_ydostoverenie === undefined) {
				response.data.anketaIp.anketa_has_ydostoverenie = '';
			}
			
			if (Array.isArray(response.data.project_data)) {
				response.data.project_data = {};
			}
			Object.keys(project_data).forEach(key => {
				if (response.data?.project_data !== null && !(key in response.data.project_data)) {
					response.data.project_data[key] = project_data[key]
				}
			});
			
			self.project = response.data;
			
			if (self.project?.zhanr === null) {
				self.project.zhanr = []
			}
			if (self.project?.stage === null) {
				self.project.stage = []
			}
			if (self.project?.project_data === null) {
				self.project.project_data = {}
			}
			if (response.data.projectSmeta) {
				self.projectSmeta = response.data.projectSmeta;
			}
			if (response.data.project_visual) {
				self.projectVisual = response.data.project_visual;
			}
			if (response.data.project_command) {
				self.projectCommand = response.data.project_command;
			}
			
			
			self.$refs?.countryAutocomlete?.setDefaultValue(response.data.country);
			self.$refs?.cityAutocomlete?.setDefaultValue(response.data.city);
			
			const response2 = await axios.get('/project/getProjectCommandData/' + window.projectId, {
				headers: {
					'Accept': 'application/json',
				}
			})
			self.currentCommand = response2.data;
			
			if (checkErrors) {
				if (showModal) {
					self.checkErrors(false, true);
				} else {
					self.checkErrors(false);
				}
			}
			
			self.isLoading = false;
			self.isDataUpdating = false;
			
			if (self.countriesinput.length === 0) {
				this.loadCountries();
			}
			
		},
		saveData: function () {
			let self = this;
			if (!this.isDataUpdating) {
				this.isDataUpdating = true;
				if (this.projectSmeta?.numCopy?.length === 0) {
					this.projectSmeta.numCopy = 0;
				}
				if (this.projectSmeta?.countZritelei?.length === 0) {
					this.projectSmeta.countZritelei = 0;
				}
				if (this.projectSmeta?.kassa?.length === 0) {
					this.projectSmeta.kassa = 0;
				}
				if (this.projectSmeta?.budget?.length === 0) {
					this.projectSmeta.budget = 0;
				}
				if (this.projectSmeta?.dohodproducer?.length === 0) {
					this.projectSmeta.dohodproducer = 0;
				}
				if (this.projectSmeta?.dohodtv?.length === 0) {
					this.projectSmeta.dohodtv = 0;
				}
				if (this.projectSmeta?.dohoddvd?.length === 0) {
					this.projectSmeta.dohoddvd = 0;
				}
				if (this.projectVisual?.predpodperiod_days?.length === 0) {
					this.projectVisual.predpodperiod_days = 0;
				}
				if (this.projectVisual?.mtperioddays?.length === 0) {
					this.projectVisual.mtperioddays = 0;
				}
				if (this.projectVisual?.podperiod_days?.length === 0) {
					this.projectVisual.podperiod_days = 0;
				}
				if (this.projectVisual?.prokatdays?.length === 0) {
					this.projectVisual.prokatdays = 0;
				}
				if (this.projectVisual?.siemochniperioddays?.length === 0) {
					this.projectVisual.siemochniperioddays = 0;
				}
				if (this.projectVisual.predpodperiod_begin?.length === 0) {
					delete this.projectVisual.predpodperiod_begin;
				}
				if (this.projectVisual.predpodperiod_end?.length === 0) {
					delete this.projectVisual.predpodperiod_end;
				}
				if (this.projectVisual.podperiodbegin?.length === 0) {
					delete this.projectVisual.podperiodbegin;
				}
				if (this.projectVisual.podperiodend?.length === 0) {
					delete this.projectVisual.podperiodend;
				}
				if (this.projectVisual.siemochniperiodbegin?.length === 0) {
					delete this.projectVisual.siemochniperiodbegin;
				}
				if (this.projectVisual.siemochniperiodend?.length === 0) {
					delete this.projectVisual.siemochniperiodend;
				}
				if (this.projectVisual.mtperiodbegin?.length === 0) {
					delete this.projectVisual.mtperiodbegin;
				}
				if (this.projectVisual.mtperiodend?.length === 0) {
					delete this.projectVisual.mtperiodend;
				}
				if (this.projectVisual.prokatbegin?.length === 0) {
					delete this.projectVisual.prokatbegin;
				}
				if (this.projectVisual.prokatend?.length === 0) {
					delete this.projectVisual.prokatend;
				}
				delete this.projectVisual.visual_image;
				
				
				axios.patch('/api/projects/' + window.projectId,
					{
						'name': this.project.name,
						'category': this.project.category,
						'zhanr': this.project.zhanr,
						'tagline': this.project.tagline,
						'logline': this.project.logline,
						'annotation': this.project.annotation,
						'chronometr': this.project.chronometr,
						'stage': this.project.stage,
						'location': this.project.location,
						'scenarioAuthor': this.project.scenario_author,
						'scenarioRights': this.project.scenario_rights,
						'country': this.project.country,
						'region': this.project.region,
						'city': this.project.city,
						'noCommand': this.project.noCommand,
						'partners_info': this.partners_info,
						'additionalInfo': this.project.additional_info,
						'projectSmeta': this.projectSmeta,
						'projectVisual': this.projectVisual,
						'projectCommand': this.projectCommand,
						'projectData': this.project.project_data,
						'anketaIp': this.project.anketaIp
					},
					{
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/merge-patch+json',
						}
					}
				).then((response) => {
					if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
						alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
						window.location.reload();
					}
					if (self.isSubmitted) {
						self.checkErrors();
					}
					self.getData()
				}).catch(error => {
					console.log(error);
					alert('Ошибка получения данных')
				});
			}
			
		},
		regionClick() {
			if (!this.isCountryFilled) {
				alert("Заполните поле Страна");
				return;
			}
			if (!this.isCityFilled) {
				alert("Заполните поле Город");
			}
			
		},
		makeProjectInfo(categoryId, isProjectInfoSubmitted) {
			
			if (isProjectInfoSubmitted === '0') {
				this.isLoading = true;
				axios.get('/competition/apiAddProject/' + this.selectedCompetitionId + '/' + window.projectId + '/' + categoryId, {
					headers: {
						'Accept': 'application/ld+json',
					}
				})
					.then(response => {
						if (response.data['error']) {
							
							alert(response.data['error'])
						}
						if (window.competitionId?.length > 0) {
							console.log('loadCompetition');
							this.loadCompetition(window.competitionId)
						} else {
							this.loadCompetitions(this.currentPageNum)
						}
						
					})
					.catch(error => {
						console.log(error);
					});
			}
		},
		setImage(e) {
			const self = this;
			const file = e.target.files[0];
			if (!file.type.includes("image/")) {
				alert("Загрузить можно только изображение");
				return;
			}
			if (file.size > 1572864) {
				alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
				return;
			}
			this.origfilename = file.name;
			
			if (typeof FileReader === "function") {
				const reader = new FileReader();
				reader.onload = event => {
					self.imgSrc = event.target.result;
					// rebuild cropperjs with the updated source
					if (self.$refs.cropper) {
						self.$refs.cropper.replace(event.target.result);
					}
				};
				reader.readAsDataURL(file);
			} else {
				alert("Sorry, FileReader API not supported");
			}
		},
		cropImage() {
			const self = this;
			this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
				let formData = new FormData();
				formData.append('file', blob);
				formData.append('original-name', self.origfilename);
				formData.append('current-name', self.project.afisha);
				
				formData.append('entity-id', self.project.id);
				
				axios(
					{
						method: 'post',
						url: '/project/getProjectAvatar',
						data: formData
					}
				)
					.then(() => {
						self.imgSrc = '';
						self.getData();
					});
			})
		},
		changeCurrentTab(num) {
			this.tabNum = num;
			document.getElementById('tabContent').scrollIntoView({behavior: 'smooth'});
		},
		isOnePredpolLocationsNotFilled(values) {
			let res = false;
			values.forEach((item) => {
				if (item.predpol_country.length === 0 || item.predpol_city.length === 0 || item.predpol_region.length === 0) {
					res = true;
				}
			});
			return res;
		},
		validateField(field) {
			const self = this;
			
			if (field.parentEntity !== undefined) {
				if (field.isRequired && (self.project[field.parentEntity] === null || self.project[field.parentEntity][field.fieldName] === undefined || (self.project[field.parentEntity][field.fieldName] === null || self.project[field.parentEntity][field.fieldName].length === 0 || self.project[field.parentEntity][field.fieldName] === 0) || (field.fieldName === 'predpol_locations' && this.isOnePredpolLocationsNotFilled(self.project[field.parentEntity][field.fieldName])))) {
					if (!self.errors.find(x => x.text === field.errorText)) {
						self.errors.push({
							text: field.errorText,
							order: field.order ? field.order : '1'
						});
					}
				}
			}
			else {
				if (field.isRequired && self.project[field.fieldName] !== undefined && (self.project[field.fieldName] === null || self.project[field.fieldName].length === 0 || self.project[field.fieldName] === 0)) {
					if (!self.errors.find(x => x.text === field.errorText)) {
						self.errors.push({
							text: field.errorText,
							order: field.order ? field.order : '1'
						});
					}
				}
				
				// Добавляем специальную валидацию для receipt_number
				if (field.fieldName === 'receipt_number' && field.isRequired) {
					if (!self.project.project_data || !self.project.project_data.receipt_number || self.project.project_data.receipt_number.trim() === '') {
						if (!self.errors.find(x => x.text === field.errorText)) {
							self.errors.push({
								text: field.errorText,
								order: field.order ? field.order : '1'
							});
						}
					} else {
						const receiptNumber = self.project.project_data.receipt_number;
						
						if (field.fieldName === 'receipt_file' && field.isRequired) {
							if (!self.project.project_data || !self.project.project_data.receipt_file || self.project.project_data.receipt_file.trim() === '') {
								if (!self.errors.find(x => x.text === field.errorText)) {
									self.errors.push({
										text: field.errorText,
										order: field.order ? field.order : '1'
									});
								}
							}
						}

						// Проверяем, что номер чека содержит ровно 10 цифр
						// if (!/^\d{10}$/.test(receiptNumber)) {
						// 	if (!self.errors.find(x => x.text === "Номер чека должен содержать ровно 10 цифр")) {
						// 		self.errors.push({
						// 			text: "Номер чека должен содержать ровно 10 цифр",
						// 			order: field.order ? field.order : '1'
						// 		});
						// 	}
						// }
						// Если формат правильный, проверяем существование в базе
						// else if (self.receiptVerificationStatus === false) {
						// 	if (!self.errors.find(x => x.text === "Указанный номер чека не найден в системе")) {
						// 		self.errors.push({
						// 			text: "Указанный номер чека не найден в системе",
						// 			order: field.order ? field.order : '1'
						// 		});
						// 	}
						// }
					}
				}
				
			}
		},
		checkIsUserFillProfile() {
			return new Promise((resolve, reject) => {
				const self = this;
				axios.get('/isUserFillProfile', {
					headers: {
						'Accept': 'application/json',
					}
				})
					.then(response => {
						self.isUserFillProfile = response.data;
						resolve(response.data)
					})
					.catch(error => {
						console.log(error);
						reject(error)
					});
			});
		},
		async checkErrors(withScroll = true, showModal = false) {
			const self = this;
			this.isLoading = true;
			self.errors = [];
			
			if (this.selectedCompetitionId === '143' &&
				this.project.project_data &&
				this.project.project_data.receipt_number) {

				// Проверяем номер чека через API
				// const receiptValid = await this.verifyReceiptNumber(this.project.project_data.receipt_number);
				//
				// if (!receiptValid) {
				// 	self.errors.push({
				// 		text: 'Указанный номер чека не найден в системе',
				// 		order: '1'
				// 	});
				// }
			}
			
			if (this.selectedCompetitionId === '143') {
				// Проверяем наличие загруженного файла
				if (!this.project.project_data || !this.project.project_data.receipt_file || this.project.project_data.receipt_file.trim() === '') {
					if (!self.errors.find(x => x.text === 'Загрузите скан чека об оплате орг. взноса')) {
						self.errors.push({
							text: 'Загрузите скан чека об оплате орг. взноса',
							order: '1'
						});
					}
				}
			}

			if (this.selectedCompetitionId === '143') {
				const receiptNumberRule = {
					fieldName: 'receipt_number',
					errorText: 'Заполните поле "Номер чека об оплате орг. взноса"',
					isRequired: true,
					order: '1'
				};
				self.validateField(receiptNumberRule);
			}
			
			
			let customFieldsValid = true;
			const customFieldsComponent = this.$refs.customFieldsRef;
			if (customFieldsComponent) {
				customFieldsValid = customFieldsComponent.validateFields();
				// Получаем ошибки из CustomFields и добавляем их в общий массив
				if (!customFieldsValid && customFieldsComponent.errors) {
					customFieldsComponent.errors.forEach(error => {
						self.errors.push({
							text: error.message,
							order: '1' // Можно настроить порядок для ошибок CustomFields
						});
					});
				}
			}
			
			this.validationRules.forEach(function (field) {
				self.validateField(field)
			});
			if (this.selectedCompetition?.projectRules) {
				this.selectedCompetition?.projectRules.forEach(function (field) {
					self.validateField(field)
				});
				this.errors.sort((a, b) => a.order > b.order ? 1 : -1);
			}
			
			if (!self.isUserFillProfile) {
				self.errors.push({
					text: 'Заполните информацию в своем Профиле <a href="https://script.moviestart.ru/myprofile?check=true">https://script.moviestart.ru/myprofile</a>',
					order: '1'
				});
			}
			if (showModal) {
				self.showModal();
			}
			self.isLoading = false;
			if (withScroll && self.errors.length > 0) {
				if (document.getElementById("project_form")) {
					document.getElementById("project_form").scrollIntoView();
				}
			}
		},
		setCompetitionId(id) {
			this.selectedCompetition = {};
			this.selectedCompetitionId = id;
			const self = this;
			this.isLoading = true;
			
			window.$.ajax({
				dataType: "json",
				type: 'get',
				contentType: "application/ld+json;",
				url: '/api/competitions/' + id,
				success: function (data) {
					if (data.projectRules !== null) {
						//self.validationRules = data.projectRules;
						self.checkErrors();
					} else {
						self.isLoading = false;
					}
				},
				error: function (data) {
					console.log(data);
				}
			});
			
		},
		onSubmit() {
			this.checkErrors();
			this.isSubmitted = true;
			const self = this;
			if (self.errors.length === 0) {
				axios.patch('/api/projects/' + window.projectId,
					{
						'isPublished': true
					},
					{
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/merge-patch+json',
						}
					}
				).then(() => {
					//console.log(response);
					if (self.isSubmitted) {
						self.checkErrors();
					}
					self.getData()
				}).catch(error => {
					console.log(error);
					alert('Ошибка получения данных')
				});
			}
		},
		isRequired(value) {
			return !(value && value.trim());
		},
		isFieldRequired(fieldName) {
			let res = false;
			
			if (fieldName === 'receipt_number' && this.selectedCompetitionId === '143') {
				return true;
			}
			
			if (fieldName === 'receipt_file' && this.selectedCompetitionId === '143') {
				return true;
			}
			
			this.validationRules.forEach(function (field) {
				if (
					(field.fieldName === fieldName || field?.altFieldName === fieldName)
					&& field.isRequired) {
					res = true;
				}
			});
			if (this.selectedCompetition?.projectRules) {
				this.selectedCompetition?.projectRules.forEach(function (field) {
					if (
						(field.fieldName === fieldName || field?.altFieldName === fieldName)
						&& field.isRequired) {
						res = true;
					}
				});
			}
			return res;
		},
		getTypeFieldByKey(key) {
			let type = '';
			if (this.selectedCompetition?.projectRules) {
				const index = this.selectedCompetition.projectRules.findIndex(object => {
					return object.fieldName === key;
				});
				if (index) {
					type = this.selectedCompetition.projectRules[index].type;
				}
			}
			return type;
		},
		isFieldVisible(fieldName) {
			let res = true;
			if (this.selectedCompetition) {
				if (this.selectedCompetition?.projectRules && Object.keys(this.selectedCompetition.projectRules).length > 0) {
					this.selectedCompetition?.projectRules.forEach(function (field) {
						if ((field.fieldName === fieldName || field?.altFieldName === fieldName) && !field.isRequired && !field.isNeeded) {
							res = false;
						}
					});
				} else {
					return false;
				}
			}
			return res;
		},
		getProjectAvatar(avatar) {
			return ImageService.getProjectImagePath(avatar);
		},
		handleValidation({isValid, errors}) {
			if (!isValid) {
				// Можно добавить дополнительную обработку ошибок
				// Например, прокрутка к первой ошибке
				const firstErrorField = document.querySelector('.error-message')
				if (firstErrorField) {
					firstErrorField.scrollIntoView({behavior: 'smooth', block: 'center'})
				}
			}
		},
		async handleReceiptNumberChange(value, key) {
			if (!this.project.project_data) {
				this.project.project_data = {};
			}
			this.project.project_data[key] = value;
			
			// Если это receipt_number, проверяем его после изменения
			if (key === 'receipt_number' && value && value.length === 10 && /^\d{10}$/.test(value)) {
				await this.verifyReceiptNumber(value);
			}
		},
		async verifyReceiptNumber(receiptNumber) {
			// Если номер не изменился с последней проверки, не делаем запрос
			if (receiptNumber === this.lastCheckedReceiptNumber && this.receiptVerificationStatus !== null) {
				return this.receiptVerificationStatus;
			}
			
			this.isReceiptVerifying = true;
			
			try {
				const response = await axios.get('/competition/check-sale-order', {
					params: {
						order_number: receiptNumber
					}
				});
				
				this.lastCheckedReceiptNumber = receiptNumber;
				this.receiptVerificationStatus = response.data.success;
				
				return response.data.success;
			} catch (error) {
				console.error('Ошибка при проверке номера чека:', error);
				this.receiptVerificationStatus = false;
				return false;
			} finally {
				this.isReceiptVerifying = false;
			}
		},
	},
	watch: {
		'selectedCompetition.competitionData.extra_fields': {
			handler(newVal) {
				if (newVal) {
					this.formFields = newVal;
				}
			},
			immediate: true
		}
	},
	
}
</script>

<template>
	<div>
		<SaveInfo
			:isDataUpdating="isDataUpdating"
		></SaveInfo>
		<div v-if="!isLoading && project.annotation !== '.'">
			<div class="content_block_top_label">
				<p v-if="selectedCompetition?.name">Текущий выбранный конкурс: <strong>{{
						selectedCompetition.name
					}}</strong>
				</p>
				<p v-if="selectedCompetition?.name" style="margin: 30px 0;"><a class="button2"
				                                                               style=" border: 2px solid #F69F22;"
				                                                               @click.prevent="showModalRequest">Подать заявку
					на конкурс</a></p>
				<p v-else style="margin: 30px 0;"><a class="button2"
				                                     @click.prevent="showModal">Перейти
					к отправке на конкурсы</a></p>
				<p>Чтобы подать проект на конкурс пройдите в раздел нужного вам конкурса и нажмите "Подать заявку"</p>
			</div>
			<div class="tabs">
				<ul>
					<li v-if="isTab1Visible" @click="changeCurrentTab(1)" class="tab tab1"
					    :class="tabNum === 1 ? 'is-active' : ''"><a>Общая информация о проекте</a></li>
					<li v-if="isFieldVisible('tizer') || isFieldVisible('refference') || isFieldVisible('regiser_eksplikatsia')"
					    @click="changeCurrentTab(2)" class="tab" :class="tabNum === 2 ? 'is-active' : ''">
						<a>Визуальная<br>
							презентация</a></li>
					<li
						v-if="isFieldVisible('predpodperiod_begin') || isFieldVisible('predpodperiod_end') || isFieldVisible('predpodperiod_days') || isFieldVisible('podperiodbegin') || isFieldVisible('podperiodend') || isFieldVisible('podperiodbegin') || isFieldVisible('podperiodend') || isFieldVisible('podperiod_days') || isFieldVisible('siemochniperiodbegin') || isFieldVisible('siemochniperiodend') || isFieldVisible('siemochniperioddays') || isFieldVisible('mtperiodbegin') || isFieldVisible('mtperiodend') || isFieldVisible('mtperioddays') || isFieldVisible('prokatbegin') || isFieldVisible('prokatend') || isFieldVisible('prokatdays')"
						@click="changeCurrentTab(3)" class="tab tab3" :class="tabNum === 3 ? 'is-active' : ''">
						<a>Предварительные<br> сроки производства</a></li>
					<li @click="changeCurrentTab(4)"
					    v-if="isFieldVisible('producer') || isFieldVisible('regiser') || isFieldVisible('scenarist') || isFieldVisible('operator') || isFieldVisible('chudoznik') || isFieldVisible('compozitor')"
					    class="tab" :class="tabNum === 4 ? 'is-active' : ''"><a>Команда</a></li>
					<li
						v-if="isFieldVisible('countZritelei') || isFieldVisible('dateRelize') || isFieldVisible('numCopy') || isFieldVisible('kassa') || isFieldVisible('budget') || isFieldVisible('dohodproducer') || isFieldVisible('dohodtv') || isFieldVisible('dohoddvd') || isFieldVisible('dohodother') || isFieldVisible('pitching') || isFieldVisible('kroud') || isFieldVisible('konception') || isFieldVisible('konceptionout') || isFieldVisible('age_limit') || isFieldVisible('partners_fin') || isFieldVisible('partners_org') || isFieldVisible('partners_info')"
						@click="changeCurrentTab(5)" class="tab" :class="tabNum === 5 ? 'is-active' : ''"><a>Смета и<br>
						маркетинг</a></li>
					<!--          <li v-if="isFieldVisible('anketa_organization_name') || isFieldVisible('organization_name_short') || isFieldVisible('anketa_ogrn') || isFieldVisible('anketa_inn') || isFieldVisible('anketa_kpp') || isFieldVisible('date_register_ip') || isFieldVisible('anketa_organization_address') || isFieldVisible('organization_address_fakt') || isFieldVisible('organization_address_notions') || isFieldVisible('fio_boss') || isFieldVisible('anketa_predstaviteli') || isFieldVisible('anketa_doverenost_litsa') || isFieldVisible('anketa_organization_email') || isFieldVisible('anketa_organization_phone') || isFieldVisible('anketa_organization_nalogi') || isFieldVisible('anketa_organization_rekviziti') || isFieldVisible('anketa_has_ydostoverenie') || isFieldVisible('anketa_ystav_copy') || isFieldVisible('anketa_gossvidetelstvo') || isFieldVisible('anketa_copy_pasport') || isFieldVisible('anketa_spravka_knd')" @click="changeCurrentTab(6)" class="tab" :class="tabNum === 6 ? 'is-active' : ''"><a>организация / <br>ИП</a></li>-->
					<!--					<li v-if="isFieldVisible('custom_fields') || formFields.length > 0" @click="changeCurrentTab(7)" class="tab"-->
					<!--					    :class="tabNum === 7 ? 'is-active' : ''">-->
					<!--						<a>Дополнительно</a>-->
					<!--					</li>-->
				</ul>
			</div>
			<form id="project_form" enctype="multipart/form-data">
				<div class="errors-block" v-if="errors.length">
					<b>Пожалуйста, заполните поля:</b>
					<ul>
						<li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
					</ul>
				</div>
				<div v-if="!selectedCompetition?.name">
					<p class="help_text" @click="showModalQuestion">
						<FontAwesomeIcon icon="question"></FontAwesomeIcon>
						Почему я не вижу обязательные поля для этого проекта?
					</p>
				</div>
				
				<div id="tabContent">
					<div v-if="tabNum === 1" id="tab1" class="content-tab">
						<div v-if="isTab1Visible" class="columns">
							<div class="column">
								
								<template v-if="selectedCompetitionId === '143'">
									<BaseInput
										label="Номер чека об оплате орг. взноса"
										:description="'<div><p>Например: 1234567890</p><p><span style=\'color: red\'>ПОЛЕ ОБЯЗАТЕЛЬНО ДЛЯ ЗАПОЛНЕНИЯ!</span>. В дальнейшем, указанный вами номер будет проверяться.</p><p><a target=\'_blank\' href=\'/images/check_example.jpg\'>Образец чека об оплате орг. взноса</a></p></div>'"
										:value="project.project_data.receipt_number || ''"
										objectKey="receipt_number"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@changeData="handleReceiptNumberChange"
									></BaseInput>
									
									<div class="form-group">
										<label class="form-label req" style="margin-bottom: 10px; display: block">Скан чека об оплате орг. взноса</label>
										<div class="form-description">
											<p>Загрузите скан чека. На указанный e-mail придет кассовый чек в течении 1 минуты. Нужно скачать его и загрузить в следующее поле.</p>
											<p class="field_description" style="font-size: 13px; margin-bottom: 10px;"><span style="color: red">ПОЛЕ ОБЯЗАТЕЛЬНО ДЛЯ ЗАПОЛНЕНИЯ!</span></p>
										</div>
										
										<a-upload
											:file-list="receiptFileList"
											:before-upload="beforeReceiptUpload"
											@remove="handleReceiptRemove"
											accept=".pdf,.png,.jpg,.jpeg"
											:max-count="1"
											:disabled="isReceiptUploading"
										>
											<a-button>
												<upload-outlined /> Выбрать файл
											</a-button>
										</a-upload>
										
										
										<div style="margin-top: 10px;" v-if="project.project_data?.receipt_file" class="uploaded-file">
											<a :href="`/uploads/files/free-cinema/${project.project_data.receipt_file}`" target="_blank">
												📎 {{ project.project_data.receipt_file }}
											</a>
											<a-button type="link" danger @click="removeReceiptFile">Удалить</a-button>
										</div>
									</div>
									
									<!-- New: Добавляем ссылку на оплату -->
									<div class="field" style="margin-bottom: 30px;">
										<p style="background: #f0f8ff; padding: 15px; border-radius: 5px; border-left: 4px solid #F69F22;">
											<strong>Для оплаты организационного взноса перейдите по ссылке:</strong><br>
											<a href="https://auth.robokassa.ru/merchant/Invoice/fSO4ygDRAkSiphKO5QGVzw"
											   target="_blank"
											   style="color: #F69F22; text-decoration: underline; font-weight: bold;">
												Оплатить организационный взнос
											</a>
										</p>
									</div>
								</template>
								
								
								<BaseInput
									v-if="isFieldVisible('name')"
									label="Название проекта"
									:value="project.name"
									objectKey="name"
									:isDataUpdated="isDataUpdating"
									:isFormSubmitted="isSubmitted"
								></BaseInput>
								
								<div class="field" v-if="isFieldVisible('category')">
									<label :class="this.isFieldRequired('category') ? 'req': ''">Формат</label>
									<div class="select-field">
										<select v-if="selectedCompetition?.formats" :disabled="isDataUpdating"
										        @change="saveData" v-model="project.category">
											<option v-for="(format,index) in selectedCompetition.formats" :key="index"
											        :value="format">{{ format }}
											</option>
										</select>
										<select v-else :disabled="isDataUpdating" @change="saveData"
										        v-model="project.category">
											<option value="Короткометражное кино">Короткометражное кино</option>
											<option value="Полнометражное кино">Полнометражное кино</option>
											<option value="Cериал">Cериал</option>
											<option value="Веб-сериал">Веб-сериал</option>
										</select>
									</div>
								</div>
								
								<div class="field" v-if="isFieldVisible('zhanr')">
									<label :class="this.isFieldRequired('zhanr') ? 'req': ''">Жанр</label>
									<div id="project_zhanr">
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_21"
											       value="Биография" v-model="project.zhanr">
											<label for="project_zhanr_21">Биография</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_1"
											       value="Боевик" v-model="project.zhanr">
											<label for="project_zhanr_1">Боевик</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_2"
											       value="Вестерн" v-model="project.zhanr">
											<label for="project_zhanr_2">Вестерн</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_3"
											       value="Детектив" v-model="project.zhanr">
											<label for="project_zhanr_3">Детектив</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_0"
											       value="Документальное" v-model="project.zhanr">
											<label for="project_zhanr_0">Документальное</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_4"
											       value="Драма" v-model="project.zhanr">
											<label for="project_zhanr_4">Драма</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_5"
											       value="Детское кино" v-model="project.zhanr">
											<label for="project_zhanr_5">Детское кино</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_6"
											       value="Исторический фильм" v-model="project.zhanr">
											<label for="project_zhanr_6">Исторический фильм</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_7"
											       value="Комедия" v-model="project.zhanr">
											<label for="project_zhanr_7">Комедия</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_8"
											       value="Мелодрама" v-model="project.zhanr">
											<label for="project_zhanr_8">Мелодрама</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_9"
											       value="Мистика" v-model="project.zhanr">
											<label for="project_zhanr_9">Мистика</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_10"
											       value="Музыкальный фильм" v-model="project.zhanr">
											<label for="project_zhanr_10">Музыкальный фильм</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_11"
											       value="Нуар" v-model="project.zhanr">
											<label for="project_zhanr_11">Нуар</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_12"
											       value="Политический фильм" v-model="project.zhanr">
											<label for="project_zhanr_12">Политический фильм</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_13"
											       value="Приключенческий фильм" v-model="project.zhanr">
											<label for="project_zhanr_13">Приключенческий фильм</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_14"
											       value="Сказка" v-model="project.zhanr">
											<label for="project_zhanr_14">Сказка</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_15"
											       value="Трагедия" v-model="project.zhanr">
											<label for="project_zhanr_15">Трагедия</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_16"
											       value="Трагикомедия" v-model="project.zhanr">
											<label for="project_zhanr_16">Трагикомедия</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_17"
											       value="Триллер" v-model="project.zhanr">
											<label for="project_zhanr_17">Триллер</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_18"
											       value="Фантастика" v-model="project.zhanr">
											<label for="project_zhanr_18">Фантастика</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_19"
											       value="Фильм-катастрофа" v-model="project.zhanr">
											<label for="project_zhanr_19">Фильм-катастрофа</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" @change="saveData" type="checkbox"
											       id="project_zhanr_20"
											       value="Фэнтези" v-model="project.zhanr">
											<label for="project_zhanr_20">Фэнтези</label></div>
									
									</div>
								</div>
								
								<div class="field" v-if="isFieldVisible('tagline')">
									<label :class="this.isFieldRequired('tagline') ? 'req': ''" for="project_tagline">Теглайн</label>
									<textarea :disabled="isDataUpdating" @change="saveData" id="project_tagline"
									          placeholder="Одна емкая фраза, отражающая главный посыл авторов фильма (до 10 слов)"
									          v-model="project.tagline"></textarea>
								</div>
								
								<div class="field" v-if="isFieldVisible('logline')">
									<label :class="this.isFieldRequired('logline') ? 'req': ''" for="project_logline">Логлайн</label>
									<textarea :disabled="isDataUpdating" @change="saveData" id="project_logline"
									          name="project[logline]"
									          placeholder="2-3 предложения, способных передать суть истории без лишних подробностей (не более 25 слов)"
									          v-model="project.logline"></textarea>
								</div>
								
								<!--              бывшая  label="Краткая аннотация" -->
								<!--                <MavonEditor-->
								<!--                    v-if="isFieldVisible('annotation')"-->
								<!--                    label="Краткий синопсис"-->
								<!--                    :value="project.annotation"-->
								<!--                    objectKey="annotation"-->
								<!--                    :isDataUpdating="isDataUpdating"-->
								<!--                ></MavonEditor>-->
								<TinymceEditor
									v-if="isFieldVisible('annotation')"
									label="Краткий синопсис"
									v-model="project.annotation"
									objectKey="annotation"
									:isDataUpdating="isDataUpdating"
								></TinymceEditor>
								
								<div class="field" v-if="isFieldVisible('chronometr')">
									<label :class="this.isFieldRequired('chronometr') ? 'req': ''"
									       for="project_chronometr">Хронометраж (в
										минутах)</label>
									<input :disabled="isDataUpdating" @change="saveData" v-model="project.chronometr"
									       type="text"
									       id="project_chronometr" name="project[chronometr]" maxlength="100">
								</div>
								
								<div class="field" v-if="isFieldVisible('stage')">
									<label :class="this.isFieldRequired('stage') ? 'req': ''">Стадия готовности
										проекта</label>
									<div id="project_stage">
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_0"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Сценарий в разработке">
											<label for="project_stage_0">Сценарий в разработке</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_1"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Сценарий написан">
											<label for="project_stage_1">Сценарий написан</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_2"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Собрана команда">
											<label for="project_stage_2">Собрана команда</label>
										</div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_3"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Препродакшн">
											<label for="project_stage_3">Препродакшн</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_4"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Продакшн">
											<label for="project_stage_4">Продакшн</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_5"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Пост-продакшн">
											<label for="project_stage_5">Пост-продакшн</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_6"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Маркетинг">
											<label for="project_stage_6">Маркетинг</label></div>
										<div class="checkbox__wrapper">
											<input :disabled="isDataUpdating" type="checkbox" id="project_stage_7"
											       name="project[stage][]"
											       v-model="project.stage" @change="saveData" value="Дистрибуция">
											<label for="project_stage_7">Дистрибуция</label></div>
									</div>
								</div>
								
								<!--              <div class="field">-->
								<!--                <label :class="this.isFieldRequired('chronometr') ? 'req': ''" for="project_location">Предполагаемое место съемок</label>-->
								<!--                <input type="text" id="project_location" name="project[location]" v-model="project.location" @change="saveData" maxlength="100">-->
								<!--              </div>-->
								
								<!--                                <BaseLocation-->
								<!--                                        v-if="project !== null && countriesinput.length > 0"-->
								<!--                                        parentObj="project_data"-->
								<!--                                        :countriesinput="countriesinput"-->
								<!--                                        :isDataUpdating="isDataUpdating"-->
								<!--                                        countryKey="predpol_country"-->
								<!--                                        cityKey="predpol_city"-->
								<!--                                        regionKey="predpol_region"-->
								<!--                                        labelCountry="Страна предполагаемого места съемок"-->
								<!--                                        labelCity="Город предполагаемого места съемок"-->
								<!--                                        labelRegion="Регион предполагаемого места съемок"-->
								<!--                                ></BaseLocation>-->
								
								
								<div class="field"
								     v-if="project !== null && isFieldVisible('predpol_locations') && countriesinput.length > 0">
									<label style="font-weight: 700;">Предполагаемые места съемок</label>
									<template v-for="(item,index) in project.project_data.predpol_locations" :key="index">
										<p><a @click="project.project_data.predpol_locations.splice(index, 1); saveData()">Удалить</a></p>
										<BaseLocationCountryRegionCity
											v-model:country="item.predpol_country"
											v-model:city="item.predpol_city"
											v-model:region="item.predpol_region"
											labelCountry="Страна предполагаемого места съемок"
											labelCity="Город предполагаемого места съемок"
											labelRegion="Регион предполагаемого места съемок"
											:is-region-required="isFieldRequired('predpol_locations')"
											:is-country-required="isFieldRequired('predpol_locations')"
											:is-city-required="isFieldRequired('predpol_locations')"
											@onChange="saveData"
										></BaseLocationCountryRegionCity>
									</template>
									<p style="margin: 30px 0;"><a class="button2"
									                              @click="project.project_data.predpol_locations.push({predpol_country: '', predpol_city: '', predpol_region: ''})"
									                              style="border: 2px solid rgb(246, 159, 34);">Добавить место съемок</a>
									</p>
								</div>
								
								
								<BasePdfUploader
									v-if="isFieldVisible('scenario')"
									:project="project"
									:currentProjectId="currentProjectId"
									label="Сценарий (в формате PDF, макс. 20 мегабайт)"
									:value="project.scenario"
									pathToUpload="/project/uploadProjectScenario/"
									:pathToDelete="'/project/removeProjectFieldPdf/'+project.id+'/scenario/project'"
									objectKey="scenario"
									:is-new-link="true"
									isTransKey=false
									@onChange="getData"
								></BasePdfUploader>
								
								<BasePdfUploader
									v-if="isFieldVisible('tritment')"
									:project="project"
									:currentProjectId="currentProjectId"
									label="Тритмент 4-7 страниц (в формате PDF, макс. 20 мегабайт)"
									:value="project?.project_data?.tritment"
									pathToUpload="/project/uploadProjectSimple/"
									:pathToDelete="'/project/removeProjectPdf/'+project.id+'/tritment/project'"
									objectKey="tritment"
									:is-new-link="true"
									isTransKey=true
									@onChange="getData"
								></BasePdfUploader>
								
								<BasePdfUploader
									v-if="isFieldVisible('sinopsis')"
									:project="project"
									:currentProjectId="currentProjectId"
									label="Синопсис (в формате PDF, макс. 20 мегабайт) - Краткое изложение сюжета (до 3 страниц)"
									:value="project.sinopsis"
									pathToUpload="/project/uploadSinopsis/"
									:pathToDelete="'/project/removeProjectFieldPdf/'+project.id+'/sinopsis/project'"
									objectKey="sinopsis"
									:is-new-link="true"
									isTransKey=false
									@onChange="getData"
								></BasePdfUploader>
								
								<BasePdfUploader
									v-if="isFieldVisible('presentation_about')"
									:project="project"
									:currentProjectId="currentProjectId"
									label="Презентация проекта (в формате PDF, макс. 20 мегабайт)"
									:value="project.presentation_about"
									pathToUpload="/project/uploadPresentation/"
									:pathToDelete="'/project/removeProjectFieldPdf/'+project.id+'/presentationAbout/project'"
									objectKey="presentationAbout"
									:is-new-link="true"
									isTransKey=false
									@onChange="getData"
								></BasePdfUploader>
								
								<div class="field" v-if="isFieldVisible('motivation')">
									<label :class="this.isFieldRequired('motivation') ? 'req': ''"
									       for="project_projectSmeta_motivation">Ваша
										личная мотивация</label>
									<textarea :disabled="isDataUpdating" @change="saveData"
									          v-model="projectSmeta.motivation"
									          id="project_projectSmeta_motivation"
									          name="project[projectSmeta][motivation]"></textarea>
								</div>
								
								<div class="field" v-if="isFieldVisible('scenario_author')">
									<label :class="this.isFieldRequired('scenario_author') ? 'req': ''"
									       for="project_scenario_author">Автор(ы)
										сценария</label>
									<textarea :disabled="isDataUpdating" @change="saveData" id="project_scenario_author"
									          name="project[scenario_author]" v-model="project.scenario_author"
									          placeholder="Напишите ФИО автора"></textarea>
								</div>
								
								<div class="field" v-if="isFieldVisible('scenario_rights')">
									<label :class="this.isFieldRequired('scenario_rights') ? 'req': ''"
									       for="project_scenario_rights">Права
										на сценарий</label>
									<textarea :disabled="isDataUpdating" @change="saveData"
									          v-model="project.scenario_rights"
									          id="project_scenario_rights" name="project[scenario_rights]"
									          placeholder="Напишите ФИО владельца"></textarea>
								</div>
								
								<div class="field" v-if="isFieldVisible('production')">
									<label :class="this.isFieldRequired('production') ? 'req': ''"
									       for="project_project_visual_production">Совместное производство</label>
									<textarea :disabled="isDataUpdating" @change="saveData"
									          id="project_project_visual_production"
									          v-model="projectVisual.production"
									          name="project[project_visual][production]"
									          placeholder="Предполагаемая копродукция"></textarea>
								</div>
								
								<div class="field" v-if="isFieldVisible('additional_info')">
									<label :class="this.isFieldRequired('additional_info') ? 'req': ''"
									       for="project_additional_info">Дополнительная информация по проекту</label>
									<textarea :disabled="isDataUpdating" @change="saveData"
									          v-model="project.additional_info"
									          id="project_additional_info" name="project[additional_info]"
									          placeholder="Здесь вы можете написать информацию о проекте, которая не подходит ни под одно из предложенных полей"></textarea>
								</div>
								<div class="field" v-if="isFieldVisible('additional_document')">
									<BasePdfUploader
										:project="project"
										:currentProjectId="currentProjectId"
										label="Дополнительные материалы: письма поддержки, информация о команде, концепция проекты и т.д.  (в формате PDF, макс. 20 мегабайт)"
										:value="project?.project_data?.additional_document"
										pathToUpload="/project/uploadProjectSimple/"
										:pathToDelete="'/project/removeProjectPdf/'+project.id+'/additional_document/project'"
										:is-new-link="true"
										objectKey="additional_document"
										isTransKey=true
										@onChange="getData"
									></BasePdfUploader>
								</div>
								
								<BaseLocation
									v-if="project !== null && countriesinput.length > 0"
									:countriesinput="countriesinput"
									countryKey="country"
									cityKey="city"
									regionKey="region"
									labelCountry="Страна"
									labelCity="Город"
									labelRegion="Регион"
									:isDataUpdating="isDataUpdating"
								></BaseLocation>
							</div>
							<div class="column">
								<template v-if="isFieldVisible('afisha')">
									<div>
										<!--                                    <img :src="'/uploads/images/' + project.afisha" id="image">-->
										<ImageRender
											id="image"
											:src="getProjectAvatar( project.afisha)"
										></ImageRender>
									</div>
									
									<div style="margin-top: 30px; margin-bottom: 30px;">
										<vue-cropper
											ref="cropper"
											:src="imgSrc"
											alt="Source Image"
											:aspect-ratio="366 / 546"
											preview=".preview"
											v-if="imgSrc != '' && isFieldVisible('afisha')"
										>
										</vue-cropper>
									</div>
									
									<button class="button2" @click.prevent="cropImage"
									        v-if="imgSrc != '' && isFieldVisible('afisha')" style="margin-right: 40px;">
										Сохранить изображение
									</button>
								</template>
								
								
								<div class="field" v-if="isFieldVisible('afisha')">
									<label :class="this.isFieldRequired('afisha') ? 'req': ''" for="project_afisha">Афиша проекта /
										Картинка характеризующая проект (Формат jpeg/png. Макс. 1,5 мегабайт)</label>
									<i class="fas fa-download"></i>
									<input :disabled="isDataUpdating" type="file" accept="image/*" id="project_afisha"
									       name="project[afisha]" @change="setImage">
									<div id="fileList"></div>
								</div>
								
								<div class="field" v-if="isFieldVisible('actual')">
									<label :class="this.isFieldRequired('actual') ? 'req': ''"
									       for="project_project_visual_actual">Обоснование актуальности проекта</label>
									<textarea :disabled="isDataUpdating" @change="saveData"
									          id="project_project_visual_actual"
									          v-model="projectVisual.actual"
									          name="project[project_visual][actual]"></textarea>
								</div>
								
								<div class="field" v-if="isFieldVisible('auditory')">
									<label :class="this.isFieldRequired('auditory') ? 'req': ''"
									       for="project_projectSmeta_auditory">Целевая
										аудитория</label>
									<textarea :disabled="isDataUpdating" @change="saveData"
									          id="project_projectSmeta_auditory"
									          v-model="projectSmeta.auditory" name="project[projectSmeta][auditory]"
									          placeholder="Напишите развернутый ответ, кто является вашей аудиторией. Сколько лет, чем занимаются, чем интересуются, где учатся, кем работают и т.д."></textarea>
								</div>
							
							</div>
						
						</div>
						<CustomFields
							ref="customFieldsRef"
							v-model:project="project"
							:fields="formFields"
							:isDataUpdating="isDataUpdating"
							@save="saveData"
							@validation="handleValidation"
						/>
					</div>
					<div v-if="tabNum === 2" class="content-tab">
						<div class="columns">
							<div class="column">
								<div class="tab_block" v-if="isFieldVisible('tizer')">
									<div class="tab_block_inner">
										<div class="columns">
											<div class="column left_column">
												<div class="field">
													<label :class="this.isFieldRequired('tizer') ? 'req': ''"
													       for="project_project_visual_tizer">Трейлер/тизер
														- Ссылка на просмотр</label>
													<input :disabled="isDataUpdating" @change="saveData" type="text"
													       v-model="projectVisual.tizer"
													       id="project_project_visual_tizer"
													       name="project[project_visual][tizer]"
													       maxlength="100">
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="field" v-if="isFieldVisible('refference')">
									<label :class="this.isFieldRequired('refference') ? 'req': ''"
									       for="project_project_visual_refference">Референсы</label>
									<textarea :disabled="isDataUpdating" @change="saveData"
									          id="project_project_visual_refference"
									          v-model="projectVisual.refference"
									          name="project[project_visual][refference]"
									          placeholder="Перечень фильмов или других визуальных изображений для более точной передачи деталей, дополнительная информация об идее"></textarea>
								</div>
								
								<BasePdfUploader
									v-if="isFieldVisible('regiser_eksplikatsia')"
									:project="project"
									:currentProjectId="currentProjectId"
									label="Режиссерская экспликация (объем не более трех страниц формата А4, в формате PDF, макс. 20 мегабайт)"
									:value="project?.project_data?.regiser_eksplikatsia"
									pathToUpload="/project/uploadProjectSimple/"
									:pathToDelete="'/project/removeProjectPdf/'+project.id+'/regiser_eksplikatsia/project'"
									objectKey="regiser_eksplikatsia"
									:is-new-link="true"
									isTransKey=true
									@onChange="getData"
								></BasePdfUploader>
							
							</div>
						</div>
					</div>
					<div v-if="tabNum === 3" class="content-tab">
						<div class="columns">
							<div class="column">
								<div class="tab_block">
									<p class="tab_block_title">СТАДИИ КИНОПРОЕКТА</p>
									<div class="tab_block_inner">
										<div class="columns">
											<div class="column left_column">
												<p v-if="isFieldVisible('predpodperiod_begin') || isFieldVisible('predpodperiod_end')">
													<strong>ПРЕДПОДГОТОВИТЕЛЬНЫЙ ПЕРИОД (РАЗРАБОТКА)</strong></p>
												<DataInput
													v-if="isFieldVisible('predpodperiod_begin')"
													:currentData="projectVisual.predpodperiod_begin"
													keyData="predpodperiod_begin"
													label="Начало"
													type="min"
													:secondValue="projectVisual.predpodperiod_end"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												<DataInput
													v-if="isFieldVisible('predpodperiod_end')"
													:currentData="projectVisual.predpodperiod_end"
													keyData="predpodperiod_end"
													label="Окончание"
													type="max"
													:secondValue="projectVisual.predpodperiod_begin"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												
												<div class="field" v-if="isFieldVisible('predpodperiod_days')">
													<label :class="this.isFieldRequired('predpodperiod_days') ? 'req': ''"
													       for="project_project_visual_predpodperiod_days">Продолжительность,
														дней</label>
													<input :disabled="isDataUpdating" @change="saveData"
													       v-model="projectVisual.predpodperiod_days" type="number"
													       id="project_project_visual_predpodperiod_days"
													       name="project[project_visual][predpodperiod_days]">
												</div>
												
												<p v-if="isFieldVisible('podperiodbegin') || isFieldVisible('podperiodend')">
													<strong>ПОДГОТОВИТЕЛЬНЫЙ ПЕРИОД</strong></p>
												<DataInput
													v-if="isFieldVisible('podperiodbegin')"
													:currentData="projectVisual.podperiodbegin"
													keyData="podperiodbegin"
													label="Начало"
													type="min"
													:secondValue="projectVisual.podperiodend"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												<DataInput
													v-if="isFieldVisible('podperiodend')"
													:currentData="projectVisual.podperiodend"
													keyData="podperiodend"
													label="Окончание"
													type="max"
													:secondValue="projectVisual.podperiodbegin"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												
												<div class="field" v-if="isFieldVisible('podperiod_days')">
													<label :class="this.isFieldRequired('podperiod_days') ? 'req': ''"
													       for="project_project_visual_podperiod_days">Продолжительность,
														дней</label>
													<input :disabled="isDataUpdating" @change="saveData"
													       v-model="projectVisual.podperiod_days"
													       type="number" id="project_project_visual_podperiod_days"
													       name="project[project_visual][podperiod_days]">
												</div>
												
												<p v-if="isFieldVisible('siemochniperiodbegin') || isFieldVisible('siemochniperiodend')">
													<strong>СЪЕМОЧНЫЙ ПЕРИОД</strong></p>
												<DataInput
													v-if="isFieldVisible('siemochniperiodbegin')"
													:currentData="projectVisual.siemochniperiodbegin"
													keyData="siemochniperiodbegin"
													label="Начало"
													type="min"
													:secondValue="projectVisual.siemochniperiodend"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												<DataInput
													v-if="isFieldVisible('siemochniperiodend')"
													:currentData="projectVisual.siemochniperiodend"
													keyData="siemochniperiodend"
													label="Окончание"
													type="max"
													:secondValue="projectVisual.siemochniperiodbegin"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												
												<div class="field" v-if="isFieldVisible('siemochniperioddays')">
													<label :class="this.isFieldRequired('siemochniperioddays') ? 'req': ''"
													       for="project_project_visual_siemochniperioddays">Продолжительность,
														дней</label>
													<input :disabled="isDataUpdating" @change="saveData"
													       v-model="projectVisual.siemochniperioddays" type="number"
													       id="project_project_visual_siemochniperioddays"
													       name="project[project_visual][siemochniperioddays]">
												</div>
											</div>
											<div class="column">
												
												<p v-if="isFieldVisible('mtperiodbegin') || isFieldVisible('mtperiodend')">
													<strong>МОНТАЖНО-ТОНИРОВОЧНЫЙ ПЕРИОД</strong></p>
												<DataInput
													v-if="isFieldVisible('mtperiodbegin')"
													:currentData="projectVisual.mtperiodbegin"
													keyData="mtperiodbegin"
													label="Начало"
													type="min"
													:secondValue="projectVisual.mtperiodend"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												<DataInput
													v-if="isFieldVisible('mtperiodend')"
													:currentData="projectVisual.mtperiodend"
													keyData="mtperiodend"
													label="Окончание"
													type="max"
													:secondValue="projectVisual.mtperiodbegin"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												
												<div class="field" v-if="isFieldVisible('mtperioddays')">
													<label :class="this.isFieldRequired('mtperioddays') ? 'req': ''"
													       for="project_project_visual_mtperioddays">Продолжительность,
														дней</label>
													<input :disabled="isDataUpdating" @change="saveData"
													       v-model="projectVisual.mtperioddays"
													       type="number" id="project_project_visual_mtperioddays"
													       name="project[project_visual][mtperioddays]">
												</div>
												
												<p v-if="isFieldVisible('prokatbegin') || isFieldVisible('prokatend')">
													<strong>ПЕРИОД ПРОКАТА</strong></p>
												
												<DataInput
													v-if="isFieldVisible('prokatbegin')"
													:currentData="projectVisual.prokatbegin"
													keyData="prokatbegin"
													label="Начало"
													type="min"
													:secondValue="projectVisual.prokatend"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												
												<DataInput
													v-if="isFieldVisible('prokatend')"
													:currentData="projectVisual.prokatend"
													keyData="prokatend"
													label="Окончание"
													type="max"
													:secondValue="projectVisual.prokatbegin"
													:isDataUpdating="isDataUpdating"
												></DataInput>
												<div class="field" v-if="isFieldVisible('prokatdays')">
													<label :class="this.isFieldRequired('prokatdays') ? 'req': ''"
													       for="project_project_visual_prokatdays">Продолжительность,
														дней</label>
													<input :disabled="isDataUpdating" @change="saveData"
													       v-model="projectVisual.prokatdays"
													       type="number" id="project_project_visual_prokatdays"
													       name="project[project_visual][prokatdays]">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum === 4" class="content-tab">
						<div class="columns">
							<div class="column">
								<div>
									<p>В том случае, если у проекта есть команда, настоятельно советуем заполнить этот
										подраздел. Так
										эксперты и продюсеры смогут оценить уровень вашей группы. Для этого необходимо,
										чтобы члены вашей
										команды зарегистрировались и максимально полно заполнили информацию о себе и вы
										сможете добавить к
										проекту ссылки на их профили.</p>
									<p class="checkbox__wrapper" style="margin-bottom: 30px">
										<input :disabled="isDataUpdating" @change="saveData" v-model="project.noCommand"
										       type="checkbox"
										       id="project_noCommand" name="project[noCommand]" value="1"><label
										for="project_noCommand"
										class="required">У меня нет
										команды</label>
									</p>
								</div>
								
								<div class="columns">
									<div class="column"
									     v-if="isFieldVisible('producer') || isFieldVisible('regiser') || isFieldVisible('scenarist')">
										<SearchTagAutocomlete
											v-if="isFieldVisible('producer')"
											:defaultData=currentCommand.producer
											keyUser="producer"
											label="Продюсер"
										></SearchTagAutocomlete>
										<SearchTagAutocomlete
											v-if="isFieldVisible('regiser')"
											:defaultData=currentCommand.regiser
											keyUser="regiser"
											label="Режиссер"
										></SearchTagAutocomlete>
										<SearchTagAutocomlete
											v-if="isFieldVisible('scenarist')"
											:defaultData=currentCommand.scenarist
											keyUser="scenarist"
											label="Сценарист"
										></SearchTagAutocomlete>
									</div>
									<div class="column"
									     v-if="isFieldVisible('operator') || isFieldVisible('chudoznik') || isFieldVisible('compositor')">
										<SearchTagAutocomlete
											v-if="isFieldVisible('operator')"
											:defaultData=currentCommand.operator
											keyUser="operator"
											label="Оператор"
										></SearchTagAutocomlete>
										<SearchTagAutocomlete
											v-if="isFieldVisible('chudoznik')"
											:defaultData=currentCommand.chudoznik
											keyUser="chudoznik"
											label="Художник"
										></SearchTagAutocomlete>
										<SearchTagAutocomlete
											v-if="isFieldVisible('compozitor')"
											:defaultData=currentCommand.compositor
											keyUser="compozitor"
											label="Композитор"
										></SearchTagAutocomlete>
									</div>
								</div>
							
							</div>
						</div>
					</div>
					<div v-if="tabNum === 5" class="content-tab">
						<div class="tab_block"
						     v-if="isFieldVisible('countZritelei') || isFieldVisible('dateRelize') || isFieldVisible('numCopy') || isFieldVisible('kassa')">
							<p class="tab_block_title" style="color: #F69F22">АУДИТОРИЯ</p>
							<div class="tab_block_inner">
								<div class="columns">
									<div class="column left_column">
										<div class="field" v-if="isFieldVisible('countZritelei')">
											<label :class="this.isFieldRequired('countZritelei') ? 'req': ''"
											       for="project_projectSmeta_countZritelei">Ожидаемое количество
												зрителей</label>
											<input :disabled="isDataUpdating" @change="saveData"
											       v-model="projectSmeta.countZritelei"
											       type="number" id="project_projectSmeta_countZritelei"
											       name="project[projectSmeta][countZritelei]">
										</div>
										<DataInputSimple
											v-if="isFieldVisible('dateRelize')"
											:currentData="projectSmeta.dateRelize"
											keyData="dateRelize"
											topLevel="projectSmeta"
											label="Предполагаемая дата релиза"
											:isDataUpdating="isDataUpdating"
										></DataInputSimple>
									</div>
									<div class="column">
										<div class="field" v-if="isFieldVisible('numCopy')">
											<label :class="this.isFieldRequired('numCopy') ? 'req': ''"
											       for="project_projectSmeta_numCopy">Число
												копий</label>
											<input :disabled="isDataUpdating" @change="saveData"
											       v-model="projectSmeta.numCopy" type="number"
											       id="project_projectSmeta_numCopy"
											       name="project[projectSmeta][numCopy]">
										</div>
										<div class="field" v-if="isFieldVisible('kassa')">
											<label :class="this.isFieldRequired('kassa') ? 'req': ''"
											       for="project_projectSmeta_kassa">Ожидаемые
												кассовые сборы</label>
											<input :disabled="isDataUpdating" @change="saveData"
											       v-model="projectSmeta.kassa" type="number"
											       id="project_projectSmeta_kassa" name="project[projectSmeta][kassa]">
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="tab_block" v-if="isFieldVisible('budget')">
							<p class="tab_block_title" style="color: #F69F22">ОБЩИЙ БЮДЖЕТ (в рублях)</p>
							<div class="tab_block_inner">
								<div class="columns">
									<div class="column left_column">
										<div class="field" v-if="isFieldVisible('budget')">
											<label :class="this.isFieldRequired('budget') ? 'req': ''"
											       for="project_projectSmeta_budget">Общий
												бюджет</label>
											<input :disabled="isDataUpdating" @change="saveData"
											       v-model="projectSmeta.budget" type="number"
											       id="project_projectSmeta_budget"
											       name="project[projectSmeta][budget]">
										</div>
									</div>
									<div class="column"></div>
								</div>
							</div>
						</div>
						
						<div class="tab_block"
						     v-if="isFieldVisible('dohodproducer') || isFieldVisible('dohodtv') || isFieldVisible('dohoddvd') || isFieldVisible('dohodother')">
							<p class="tab_block_title" style="color: #F69F22">ОКУПАЕМОСТЬ/БЮДЖЕТ ДОХОДОВ И РАСХОДОВ
								КИНОПРОЕКТА</p>
							<div class="tab_block_inner">
								<div class="columns">
									<div class="column">
										<p><strong>ДОХОДЫ КИНОПРОЕКТА</strong></p>
										
										<div class="field" v-if="isFieldVisible('dohodproducer')">
											<label :class="this.isFieldRequired('dohodproducer') ? 'req': ''"
											       for="project_projectSmeta_dohodproducer">Доход продюсера от
												проката</label>
											<input :disabled="isDataUpdating" @change="saveData"
											       v-model="projectSmeta.dohodproducer"
											       type="number" id="project_projectSmeta_dohodproducer"
											       name="project[projectSmeta][dohodproducer]">
										</div>
										
										<div class="field" v-if="isFieldVisible('dohodtv')">
											<label :class="this.isFieldRequired('dohodtv') ? 'req': ''"
											       for="project_projectSmeta_dohodtv">Продажа
												прав на ТВ</label>
											<input :disabled="isDataUpdating" @change="saveData"
											       v-model="projectSmeta.dohodtv" type="number"
											       id="project_projectSmeta_dohodtv"
											       name="project[projectSmeta][dohodtv]">
										</div>
										
										<div class="field" v-if="isFieldVisible('dohoddvd')">
											<label :class="this.isFieldRequired('dohoddvd') ? 'req': ''"
											       for="project_projectSmeta_dohoddvd">Продажа
												прав на VoD</label>
											<input :disabled="isDataUpdating" @change="saveData"
											       v-model="projectSmeta.dohoddvd" type="number"
											       id="project_projectSmeta_dohoddvd"
											       name="project[projectSmeta][dohoddvd]">
										</div>
										
										<div class="field" v-if="isFieldVisible('dohodother')">
											<label :class="this.isFieldRequired('dohodother') ? 'req': ''"
											       for="project_projectSmeta_dohodother">Другие доходы (перечислете
												через запятую, если больше
												одного)</label>
											<textarea :disabled="isDataUpdating" @change="saveData"
											          v-model="projectSmeta.dohodother"
											          id="project_projectSmeta_dohodother"
											          name="project[projectSmeta][dohodother]"></textarea>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="tab_block"
						     v-if="isFieldVisible('pitching') || isFieldVisible('kroud') || isFieldVisible('konception') || isFieldVisible('konceptionout')">
							<p class="tab_block_title" style="color: #F69F22">ПРОДВИЖЕНИЕ ПРОЕКТА/PR</p>
							<div class="tab_block_inner">
								<div class="columns">
									<div class="column left_column">
										<div class="field" v-if="isFieldVisible('pitching')">
											<label :class="this.isFieldRequired('pitching') ? 'req': ''"
											       for="project_projectSmeta_pitching">Участие
												в питчингах и сценарных лабораториях</label>
											<textarea :disabled="isDataUpdating" @change="saveData"
											          v-model="projectSmeta.pitching"
											          id="project_projectSmeta_pitching"
											          name="project[projectSmeta][pitching]"></textarea>
										</div>
										
										<div class="field" v-if="isFieldVisible('kroud')">
											<label :class="this.isFieldRequired('kroud') ? 'req': ''"
											       for="project_projectSmeta_kroud">Опыт
												краудфандинга</label>
											<textarea :disabled="isDataUpdating" @change="saveData"
											          v-model="projectSmeta.kroud"
											          id="project_projectSmeta_kroud"
											          name="project[projectSmeta][kroud]"></textarea>
										</div>
									</div>
									<div class="column">
										<div class="field" v-if="isFieldVisible('konception')">
											<label :class="this.isFieldRequired('konception') ? 'req': ''"
											       for="project_projectSmeta_konception">Маркетинговый план продвижения
												проекта</label>
											<textarea :disabled="isDataUpdating" @change="saveData"
											          v-model="projectSmeta.konception"
											          id="project_projectSmeta_konception"
											          name="project[projectSmeta][konception]"></textarea>
										</div>
										<div class="field" v-if="isFieldVisible('konceptionout')">
											<label :class="this.isFieldRequired('konceptionout') ? 'req': ''"
											       for="project_projectSmeta_konceptionout">Маркетинговый план выхода на
												рынок</label>
											<textarea :disabled="isDataUpdating" @change="saveData"
											          v-model="projectSmeta.konceptionout"
											          id="project_projectSmeta_konceptionout"
											          name="project[projectSmeta][konceptionout]"></textarea>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="tab_block" v-if="isFieldVisible('age_limit')">
							<div class="tab_block_inner">
								<div class="columns">
									<div class="column left_column">
										<BaseJsonField
											v-if="isFieldVisible('age_limit')"
											label="Возрастные ограничения"
											keyData="age_limit"
											:currentData="project.project_data.age_limit"
											type="input"
											:isDataUpdating="isDataUpdating"
										></BaseJsonField>
									</div>
								</div>
							</div>
						</div>
						
						<div class="tab_block"
						     v-if="isFieldVisible('partners_fin') || isFieldVisible('partners_org') || isFieldVisible('partners_info')">
							<p class="tab_block_title" style="color: #F69F22">Партнеры проекта</p>
							<div class="tab_block_inner">
								<div class="columns">
									<div class="column left_column">
										
										<BaseJsonField
											v-if="isFieldVisible('partners_fin')"
											label="Финансовые"
											keyData="partners_fin"
											:currentData="project.project_data.partners_fin"
											type="textarea"
											:isDataUpdating="isDataUpdating"
										></BaseJsonField>
										
										<BaseJsonField
											v-if="isFieldVisible('partners_org')"
											label="Организационные"
											keyData="partners_org"
											:currentData="project.project_data.partners_org"
											type="textarea"
											:isDataUpdating="isDataUpdating"
										></BaseJsonField>
										
										<BaseJsonField
											v-if="isFieldVisible('partners_info')"
											label="Информационные"
											keyData="partners_info"
											:currentData="project.project_data.partners_info"
											type="textarea"
											:isDataUpdating="isDataUpdating"
										></BaseJsonField>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum === 6" class="content-tab">
						<div class="columns">
							<div class="column">
								<template v-if="project.anketaIp !== undefined">
									<div class="field" v-if="isFieldVisible('anketa_organization_name')">
										<label :class="this.isFieldRequired('anketa_organization_name') ? 'req': ''">Полное
											наименование
											организации либо фамилия, имя и отчество (при наличии) Участника -
											индивидуального
											предпринимателя</label>
										<textarea :disabled="isDataUpdating" @change="saveData"
										          v-model="project.anketaIp.anketa_organization_name"></textarea>
									</div>
									<div class="field" v-if="isFieldVisible('organization_name_short')">
										<label :class="this.isFieldRequired('organization_name_short') ? 'req': ''">Сокращенное
											наименование
											организации (для юридических лиц)</label>
										<textarea :disabled="isDataUpdating" @change="saveData"
										          v-model="project.anketaIp.organization_name_short"></textarea>
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_ogrn')">
										<label :class="this.isFieldRequired('anketa_ogrn') ? 'req': ''">ОГРН/ОГРНИП</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.anketa_ogrn">
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_inn')">
										<label :class="this.isFieldRequired('anketa_inn') ? 'req': ''">ИНН</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.anketa_inn">
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_kpp')">
										<label :class="this.isFieldRequired('anketa_kpp') ? 'req': ''">КПП (для
											юридических лиц)</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.anketa_kpp">
									</div>
									
									<div class="field" v-if="isFieldVisible('date_register_ip')">
										<label :class="this.isFieldRequired('date_register_ip') ? 'req': ''">Дата
											регистрации
											организации/индивидуального предпринимателя</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.date_register_ip">
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_organization_address')">
										<label :class="this.isFieldRequired('anketa_organization_address') ? 'req': ''">Адрес
											(местонахождение)/местожительства (для индивидуального
											предпринимателя)</label>
										<textarea :disabled="isDataUpdating" @change="saveData"
										          v-model="project.anketaIp.anketa_organization_address"></textarea>
									</div>
									
									<div class="field" v-if="isFieldVisible('organization_address_fakt')">
										<label :class="this.isFieldRequired('organization_address_fakt') ? 'req': ''">Фактическое
											местонахождение организации/ индивидуального предпринимателя</label>
										<textarea :disabled="isDataUpdating" @change="saveData"
										          v-model="project.anketaIp.organization_address_fakt"></textarea>
									</div>
									
									<div class="field" v-if="isFieldVisible('organization_address_notions')">
										<label :class="this.isFieldRequired('organization_address_notions') ? 'req': ''">Адрес
											для
											направления организации/индивидуальному предпринимателю юридически значимых
											сообщений</label>
										<textarea :disabled="isDataUpdating" @change="saveData"
										          v-model="project.anketaIp.organization_address_notions"></textarea>
									</div>
									
									<div class="field" v-if="isFieldVisible('fio_boss')">
										<label :class="this.isFieldRequired('fio_boss') ? 'req': ''">Фамилия, имя и
											отчество (при наличии)
											руководителя организации</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.fio_boss">
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_predstaviteli')">
										<label :class="this.isFieldRequired('anketa_predstaviteli') ? 'req': ''">Сведения
											о лице,
											уполномоченном действовать от имени Участника по доверенности (если
											применимо)</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.anketa_predstaviteli">
									</div>
									
									<BasePdfUploader
										v-if="isFieldVisible('anketa_doverenost_litsa')"
										:project="project"
										:currentProjectId="currentProjectId"
										label="Доверенность лица, уполномоченного действовать от имени Участника по доверенности (если применимо) (в формате PDF, макс. 20 мегабайт)"
										:value="project?.project_data?.anketa_doverenost_litsa"
										pathToUpload="/project/uploadProjectSimple/"
										:pathToDelete="'/project/removeProjectPdf/'+project.id+'/anketa_doverenost_litsa/project'"
										objectKey="anketa_doverenost_litsa"
										:is-new-link="true"
										@onChange="getData"
										isTransKey=true
									></BasePdfUploader>
									
									<div class="field" v-if="isFieldVisible('anketa_organization_email')">
										<label :class="this.isFieldRequired('anketa_organization_email') ? 'req': ''">Адрес
											электронной
											почты
											организации/индивидуального предпринимателя</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.anketa_organization_email">
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_organization_phone')">
										<label :class="this.isFieldRequired('anketa_organization_phone') ? 'req': ''">Контактный
											телефон</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.anketa_organization_phone">
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_organization_nalogi')">
										<label :class="this.isFieldRequired('anketa_organization_nalogi') ? 'req': ''">Система
											налогообложения (ОСНО, УСН 15%, УСН 6%)</label>
										<input :disabled="isDataUpdating" @change="saveData" type="text"
										       v-model="project.anketaIp.anketa_organization_nalogi">
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_organization_rekviziti')">
										<label :class="this.isFieldRequired('anketa_organization_rekviziti') ? 'req': ''">Банковские
											реквизиты:<br>
											1. Расчетный счет<br>
											2. Банковский идентификационный код(БИК)<br>
											3. Название банка<br>
											4. Корреспондентский счет<br>
											5. Лицевой счет в УФК (при наличии)<br>
											6.Наименование территориального органа Федерального казначейства (при
											наличии)
										</label>
										<textarea :disabled="isDataUpdating" @change="saveData"
										          v-model="project.anketaIp.anketa_organization_rekviziti"></textarea>
									</div>
									
									<div class="field" v-if="isFieldVisible('anketa_has_ydostoverenie')">
										<label :class="this.isFieldRequired('anketa_has_ydostoverenie') ? 'req': ''"
										       for="user_fprk_ydostoverenie">Наличие удостоверения национального
											фильма/планируется ли получение удостоверения
											национального фильма</label>
										<div class="select-field">
											<select :disabled="isDataUpdating" @change="saveData"
											        v-model="project.anketaIp.anketa_has_ydostoverenie"
											        id="user_fprk_ydostoverenie"
											        name="user_fprk[ydostoverenie]" data-jsontype="data-jsontype">
												<option value="yes" selected="selected">Да</option>
												<option value="no">Нет</option>
											</select>
										</div>
									</div>
									
									<BasePdfUploader
										v-if="isFieldVisible('anketa_ystav_copy')"
										:project="project"
										:currentProjectId="currentProjectId"
										label="Копия устава (в формате PDF, макс. 20 мегабайт)"
										:value="project?.project_data?.anketa_ystav_copy"
										pathToUpload="/project/uploadProjectSimple/"
										:pathToDelete="'/project/removeProjectPdf/'+project.id+'/anketa_ystav_copy/project'"
										objectKey="anketa_ystav_copy"
										:is-new-link="true"
										isTransKey=true
										@onChange="getData"
									></BasePdfUploader>
									
									<BasePdfUploader
										v-if="isFieldVisible('anketa_gossvidetelstvo')"
										:project="project"
										:currentProjectId="currentProjectId"
										label="Свидетельство о государственной регистрации или Лист записи ЕГРЮЛ/ЕГРИП (в формате PDF, макс. 20 мегабайт)"
										:value="project?.project_data?.anketa_gossvidetelstvo"
										pathToUpload="/project/uploadProjectSimple/"
										:pathToDelete="'/project/removeProjectPdf/'+project.id+'/anketa_gossvidetelstvo/project'"
										objectKey="anketa_gossvidetelstvo"
										:is-new-link="true"
										isTransKey=true
										@onChange="getData"
									></BasePdfUploader>
									
									
									<BasePdfUploader
										v-if="isFieldVisible('anketa_copy_pasport')"
										:project="project"
										:currentProjectId="currentProjectId"
										label="Копия паспорта (для индивидуальных предпринимателей) (в формате PDF, макс. 20 мегабайт)"
										:value="project?.project_data?.anketa_copy_pasport"
										pathToUpload="/project/uploadProjectSimple/"
										:pathToDelete="'/project/removeProjectPdf/'+project.id+'/anketa_copy_pasport/project'"
										objectKey="anketa_copy_pasport"
										:is-new-link="true"
										isTransKey=true
										@onChange="getData"
									></BasePdfUploader>
									
									<BasePdfUploader
										v-if="isFieldVisible('anketa_spravka_knd')"
										:project="project"
										:currentProjectId="currentProjectId"
										label="Справка по форме КНД 1120101 / Гарантийное письмо о предоставлении справки (в формате PDF, макс. 20 мегабайт)"
										:value="project?.project_data?.anketa_spravka_knd"
										pathToUpload="/project/uploadProjectSimple/"
										:pathToDelete="'/project/removeProjectPdf/'+project.id+'/anketa_spravka_knd/project'"
										objectKey="anketa_spravka_knd"
										:is-new-link="true"
										isTransKey=true
										@onChange="getData"
									></BasePdfUploader>
								
								</template>
							</div>
						</div>
					</div>
					<!--					<div v-if="tabNum === 7" class="content-tab">-->
					<!--						<div class="columns">-->
					<!--							<div class="column">-->
					<!--								<div class="tab_block">-->
					<!--									<div class="tab_block_inner">-->
					<!--										<CustomFields-->
					<!--											ref="customFieldsTabRef"-->
					<!--											v-model:project="project"-->
					<!--											:fields="formFields"-->
					<!--											:isDataUpdating="isDataUpdating"-->
					<!--											@save="saveData"-->
					<!--											@validation="handleValidation"-->
					<!--										/>-->
					<!--									</div>-->
					<!--								</div>-->
					<!--							</div>-->
					<!--						</div>-->
					<!--					</div>-->
				</div>
				<!--        <p>Чтобы подать проект на конкурс пройдите в <a href="/competition/list">раздел нужного вам конкурса</a> и нажмите "Подать заявку"</p>-->
				<p>Информация введенная в поля анкеты сохраняется автоматически.</p>
				<!--        <p v-if="!project.isPublished"><input class="button2" name="publish_save"  style="margin-top: 0;" type="submit" value="Опубликовать"></p>-->
			</form>
		</div>
		<div v-else style="text-align: center">
			<div class="lds-default">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
		
		<a-modal
			v-model:visible="isShow"
			:footer="null"
			width="70%"
			:destroyOnClose="true"
			:style="{ 'max-width': '1000px' }"
		>
			<template v-if="competitionMode">
				<div v-if="selectedCompetitionId === 0">
					<h1 style="margin-bottom: 85px;">Конкурсы</h1>
					<template v-if="isLoading">
						<div class="lds-default">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
					</template>
					<template v-else>
						<div class="columns is-multiline">
							<div v-for="(competition, index) in competitions"
							     :class="index % 2 === 0 ? 'col1' : 'col2'"
							     class="column competition_wrapper is-5-desktop"
							     :data-competitionid="competition.id"
							     :key="competition.id">
								<div class="competition_wrapper_inner" style="position: relative">
									<div class="competition-image-wrapper">
										<ImageRender
											:src="get_uploaded_image_asset(competition.avatar)"
											class-name="competition_image"
										/>
										<!--										<img class="competition_image" :src="competition.clearAvatar">-->
									</div>
									<div class="competiton_order_button_div">
										<a @click="setCompetitionId(competition.id)"
										   class="button2 competiton_order_button">Подать
											заявку</a>
									</div>
								</div>
								
								<div class="competition-info">
									<p class="competition-type">{{ competition.napravlenie }}</p>
									<p class="competition-title__wrapper"><a class="competition-title"
									                                         :href="'/competition/single/' + competition.id">{{
											competition.name
										}}</a></p>
								</div>
								
								<div class="competition_do">
									ДО<br>
									{{ formatCompetitionDate(competition.endDate) }}
								</div>
							</div>
						</div>
						<Pagination
							perPage=10
							@updateParentData="loadCompetitions"
							:totalItems="totalCompetitions"
							:currentPageNum="currentPageNum"
						></Pagination>
					</template>
				</div>
				<div class="choise_category" v-else>
					
					<p v-if="windowCompetitionId.length === 0"><a @click="selectedCompetitionId = 0">Выбрать другой
						конкурс</a>
					</p>
					
					<template v-if="selectedCompetition?.isUserAgeRight">
						<h1 v-if="errors.length === 0">Выберите категорию конкурса<br> {{ selectedCompetition?.name }}</h1>
						<div v-if="isLoading">
							<div class="lds-default">
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
							</div>
						</div>
						<div v-else>
							<div class="errors-block" v-if="errors.length">
								<b style="color:#000;">Для этого конкурса нужно заполнить следующие поля:</b>
								<ul>
									<li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
								</ul>
								<p><a @click="closeModal">Заполнить поля</a></p>
							</div>
							<div v-else>
								<p class="category_select"
								   :class="category.isProjectInfoSubmitted === '1' ? 'category_select_active' : ''"
								   @click="makeProjectInfo(category.id, category.isProjectInfoSubmitted)"
								   v-for="category in selectedCompetition?.categories" :key="category.id"><i
									v-if="category.isProjectInfoSubmitted === '1'"
									style="color: green; margin-right: 10px;"
									class="fas fa-check-square"></i> {{ category.name }} <span
									v-if="category.isProjectInfoSubmitted === '1'">(Заявка подана)</span></p>
								<template v-if="selectedCompetition.id === 81 && modalStep === 1">
									<p>
										<button style="background: #EE9D46; border: 0; color: #fff"
										        @click="modalStep=0" class="button2">Назад
										</button>
									</p>
								</template>
							</div>
						</div>
					</template>
					<template v-else>
						<div>
							<template v-if="selectedCompetition?.competitionData?.['age_description']">
								{{ selectedCompetition?.competitionData?.['age_description'] }}
							</template>
							<template v-else>
								<p>Для этого конкурса заданы возрастные ограничения. Проверьте свой профиль.</p>
							</template>
						</div>
					</template>
				</div>
			</template>
			<template v-if="questionMode">
				<QuestionText1/>
			</template>
		</a-modal>
	</div>
</template>

<style scoped>
.modal {
	display: block;
	width: 80%;
	max-width: 950px;
	box-sizing: border-box;
	font-size: 20px;
	text-align: center;
	margin: 30px auto 30px;
	position: relative;
}

.category_select_active {
	font-weight: bold;
}

.close_button {
	position: absolute;
	right: 15px;
	top: 10px;
	font-size: 20px;
	cursor: pointer;
}

.vue-universal-modal {
	z-index: 111;
}

.errors-block {
	color: red;
	border: 1px solid #999;
	border-radius: 10px;
	padding: 25px;
	margin-bottom: 30px;
}

.lds-default {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
	transform: scale(0.5);
	text-align: center;
}

.lds-default div {
	position: absolute;
	width: 6px;
	height: 6px;
	background: #000;
	border-radius: 50%;
	animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
	animation-delay: 0s;
	top: 37px;
	left: 66px;
}

.lds-default div:nth-child(2) {
	animation-delay: -0.1s;
	top: 22px;
	left: 62px;
}

.lds-default div:nth-child(3) {
	animation-delay: -0.2s;
	top: 11px;
	left: 52px;
}

.lds-default div:nth-child(4) {
	animation-delay: -0.3s;
	top: 7px;
	left: 37px;
}

.lds-default div:nth-child(5) {
	animation-delay: -0.4s;
	top: 11px;
	left: 22px;
}

.lds-default div:nth-child(6) {
	animation-delay: -0.5s;
	top: 22px;
	left: 11px;
}

.lds-default div:nth-child(7) {
	animation-delay: -0.6s;
	top: 37px;
	left: 7px;
}

.lds-default div:nth-child(8) {
	animation-delay: -0.7s;
	top: 52px;
	left: 11px;
}

.lds-default div:nth-child(9) {
	animation-delay: -0.8s;
	top: 62px;
	left: 22px;
}

.lds-default div:nth-child(10) {
	animation-delay: -0.9s;
	top: 66px;
	left: 37px;
}

.lds-default div:nth-child(11) {
	animation-delay: -1s;
	top: 62px;
	left: 52px;
}

.lds-default div:nth-child(12) {
	animation-delay: -1.1s;
	top: 52px;
	left: 62px;
}

.competition_wrapper {
	position: relative;
	max-width: 355px;
}

.modal .columns.is-multiline {
	justify-content: center;
}

.modal .columns.is-multiline .col1 {
	margin-right: 50px;
	margin-bottom: 70px;
}

.competiton_order_button_div {
	display: none;
}

.competition-info {
	background: #FEF4E5;
	padding: 20px;
}

.competition-image-wrapper {
	position: relative;
	display: flex;
	border-bottom: 5px solid #F69F22;
}

.cabinet_page .container .choise_category h1 {
	font-size: 25px;
}

.vue-universal-modal {
	z-index: 111;
}

.competition-title__wrapper {
	line-height: 1;
}

.competition-title {
	font-size: 16px;
}

.category_select {
	font-size: 18px;
}

.content_block .tabs ul {
	align-items: inherit;
}

.content_block .tabs ul li {
	display: flex;
}

.category_select:hover {
	color: #F69F22;
	cursor: pointer;
}

.help_text {
	margin-bottom: 30px;
	margin-top: 30px;
	font-style: italic;
	color: #8F9194;
	cursor: pointer;
}

.help_text svg {
	margin-right: 10px;
}

.modal_question {
	text-align: left;
	font-size: 16px;
}

@keyframes lds-default {
	0%, 20%, 80%, 100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.5);
	}
}
</style>
